export default __webpack_public_path__ + "static/media/counselor_management.ce94a0e3.png";